module.exports = __webpack_public_path__ + "img/e-commerce.c46c5198.svg";